import Component from './ReportCreator.vue';

export default {
  install(Vue) {
    Vue.component('BkfReportCreator', Component);
  },
};
